import { FC } from 'react';
import { CheckboxSingle } from '../../../../common/components/CheckboxSingle/CheckboxSingle';
import { css } from '@bts-web/utils-style-engine';

const FATCACheckboxEntry: FC<{
  label: string;
  name: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  additionalElements?: React.ReactNode;
}> = ({ checked, label, name, onChange, disabled, additionalElements }) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();

        e.preventDefault();

        onChange();
      }}
      disabled={disabled}
      type="button"
      className={css({
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 'small',
        padding: 'small',
        backgroundColor:
          disabled && !checked ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        _hover: {
          backgroundColor: disabled ? '#f0f0f0' : 'rgba(0, 0, 0, 0.03)',
        },
        borderRadius: '12px',
        border: '1px solid',
        borderColor:
          disabled && !checked ? 'transparent' : 'rgba(0, 0, 0, 0.15)',
        lineHeight: 1,
      })}
    >
      <CheckboxSingle checked={checked} name={name} disabled={disabled} />
      <span>{label}</span>
      {additionalElements && additionalElements}
    </button>
  );
};

export { FATCACheckboxEntry };
